<template>
  <div>
    <div
      class="maps"
      element-loading-text="加载中..."
      element-loading-background="rgba(0, 0, 0, 0.4)"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <div style="width: 38%">
        <el-card class="box-card common">
          <div>
            <span class="bb">
              报备 /
              <i>次</i>
            </span>
          </div>
          <div class="all">
            <!-- 假数据 -->
            <p id="time1">{{ total.reportNums }}</p>
            <p>累计总报备</p>
          </div>
          <div class="add">
            新增
            <span id="time1_add">{{ total.addReportNums }}</span> 次
          </div>
        </el-card>
        <el-card class="box-card common">
          <div>
            <span class="bb">
              食安办 /
              <i>人</i>
            </span>
          </div>
          <div class="all">
            <p id="time2">{{ total.sabNums }}</p>
            <p>累计总人数</p>
          </div>
          <div class="add">
            新增
            <span id="time2_add">{{ total.addSabNums }}</span> 人
          </div>
        </el-card>
        <el-card class="box-card common">
          <div>
            <span class="bb">
              协管员 /
              <i>人</i>
            </span>
          </div>
          <div class="all">
            <p id="time3">{{ total.xgNums }}</p>
            <p>累计总人数</p>
          </div>
          <div class="add">
            新增
            <span id="time3_add">{{ total.addXgNums }}</span> 人
          </div>
        </el-card>
        <el-card class="box-card common" style="margin-bottom: 0px">
          <div>
            <span class="bb">
              乡厨 /
              <i>人</i>
            </span>
          </div>
          <div class="all">
            <p id="time4">{{ total.xcNums }}</p>
            <p>累计总人数</p>
          </div>
          <div class="add">
            新增
            <span id="time4_add">{{ total.addXcNums }}</span> 人
          </div>
        </el-card>
      </div>
      <div
        style="width: 60%; height: auto; margin-left: 1.8%; position: relative"
      >
        <div class="maptit">
          <span style="border-left: 5px solid #11A983; padding-left: 16px"
            >近期办宴分布</span
          >
          <span>
            <img src="../assets/img/hong.png" />今天 &nbsp;&nbsp;
            <img src="../assets/img/huang.png" />前3日 &nbsp;&nbsp;
            <img src="../assets/img/lan.png" />近期
          </span>
        </div>
        <!-- <div id="boxMap" class="map"></div> -->
        <baidu-map
          class="map"
          :center="mapcent"
          :zoom="12"
          :scroll-wheel-zoom="true"
        >
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
          <div v-for="(item, index) in map" :key="index">
            <bm-marker
              v-if="item.dayType == 1"
              :icon="{ url: imgUrl(item), size: { width: 32, height: 32 } }"
              @click="ceshi(item, index)"
              :position="{ lng: item.lng, lat: item.lat }"
              :dragging="false"
              animation="BMAP_ANIMATION_BOUNCE"
            >
              <bm-label
                @click="off"
                :content="newcont"
                v-if="mapstat == index"
                :labelStyle="{
                  color: 'black',
                  fontSize: '12px',
                  border: 'none',
                  background: 'none',
                }"
                :offset="{ width: -35, height: 30 }"
              />
            </bm-marker>
            <bm-marker
              v-else
              :icon="{ url: imgUrl(item), size: { width: 32, height: 32 } }"
              @click="ceshi(item, index)"
              :position="{ lng: item.lng, lat: item.lat }"
              :dragging="true"
            >
              <bm-label
                @click="off"
                :content="newcont"
                v-if="mapstat == index"
                :labelStyle="{
                  color: 'black',
                  fontSize: '12px',
                  border: 'none',
                  background: 'none',
                }"
                :offset="{ width: -35, height: 30 }"
              />
            </bm-marker>
          </div>
        </baidu-map>
      </div>
    </div>
    <!-- 今日办宴列表数据卡片 -->
    <el-card class="box-card" style="margin-top: 24px">
      <div slot="header" class="clearfix">
        <span>今日办宴</span>
      </div>
      <el-table :data="tableData1" border stripe style="width: 100%">
        <el-table-column label="办宴时间">
          <template slot-scope="scope">
            <p>{{ scope.row.dinnertime.substring(0, 10) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴区域">
          <template slot-scope="scope">
            <p>{{ scope.row.city }}{{ scope.row.district }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴类型">
          <template slot-scope="scope">
            <!-- <p>{{ stat(scope.row.dinnertype) }}</p> -->
            <p v-if="scope.row.dinnertype == 1" style="color: #ff0000; font-weight: 600;">红事</p>
            <p v-if="scope.row.dinnertype == 2" style="color: #000000; font-weight: 600;">白事</p>
            <p v-if="scope.row.dinnertype == 3" style="color: #ff0000; font-weight: 600;">生日</p>
            <p v-if="scope.row.dinnertype == 4" style="color: #ff0000; font-weight: 600;">状元</p>
            <p v-if="scope.row.dinnertype == 5" style="color: #ff0000; font-weight: 600;">乔迁</p>
            <p v-if="scope.row.dinnertype == 6" style="color: #11A983; font-weight: 600;">其他</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴天数">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDays }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴桌数">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDesk }}</p>
          </template>
        </el-table-column>
        <el-table-column label="参宴人数">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDiners }}</p>
          </template>
        </el-table-column>
        <el-table-column label="现场监控">
          <template slot-scope="scope">
            <p class="f18" @click="govideo(scope.row)">
              <i class="iconfont icon-video"></i>现场监控
            </p>
          </template>
        </el-table-column>
        <el-table-column label="溯源信息">
          <template slot-scope="scope">
            <p class="f19" @click="gofoot(scope.row)">
              <i class="iconfont icon-caigou"></i>溯源信息
            </p>
          </template>
        </el-table-column>
        <el-table-column label="运输信息">
          <template slot-scope="scope">
            <p class="f20" @click="transport(scope.row)">
              <i class="iconfont icon-yunshu"></i>运输信息
            </p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="paging" v-if="totalTodayDinner != 0">
        <span>共 <i class="pagingNum">{{ totalTodayDinner }}</i> 条</span>
        <Paging :gopage="totalTodayDinner" @pag="pageTodayDinner"></Paging>
      </div>
    </el-card>
    <!-- 今日报备列表数据卡片 -->
    <el-card class="box-card" style="margin-top: 24px">
      <div slot="header" class="clearfix">
        <span>今日报备</span>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column label="办宴时间">
          <template slot-scope="scope">
            <p>{{ scope.row.dinnertime.substring(0, 10) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴区域">
          <template slot-scope="scope">
            <p>{{ scope.row.city }}{{ scope.row.district }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴类型">
          <template slot-scope="scope">
            <!-- <p>{{ stat(scope.row.dinnertype) }}</p> -->
            <p v-if="scope.row.dinnertype == 1" style="color: #ff0000; font-weight: 600;">红事</p>
            <p v-if="scope.row.dinnertype == 2" style="color: #000000; font-weight: 600;">白事</p>
            <p v-if="scope.row.dinnertype == 3" style="color: #ff0000; font-weight: 600;">生日</p>
            <p v-if="scope.row.dinnertype == 4" style="color: #ff0000; font-weight: 600;">状元</p>
            <p v-if="scope.row.dinnertype == 5" style="color: #ff0000; font-weight: 600;">乔迁</p>
            <p v-if="scope.row.dinnertype == 6" style="color: #11A983; font-weight: 600;">其他</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴天数">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDays }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴桌数">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDesk }}</p>
          </template>
        </el-table-column>
        <el-table-column label="参宴人数">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDiners }}</p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="paging"  v-if="totalTodayReport != 0">
        <span>共 <i class="pagingNum">{{ totalTodayReport }}</i> 条</span>
        <Paging :gopage="totalTodayReport" @pag="pageTodayReport"></Paging>
      </div>
    </el-card>
    <!-- 今日办宴统计百度图表 -->
    <el-card class="box-card bdechart onecha">
      <div id="main" style="width: 100%; height: 500px"></div>
    </el-card>
    <!-- 今日报备统计百度图表 -->
    <el-card class="box-card bdechart">
      <div id="main1" style="width: 100%; height: 500px"></div>
    </el-card>
    <!-- 底部空白 -->
    <el-card style="width: 100%; height: 0;background-color: #E9ECF3; box-shadow: 0 0 0 0;">
    </el-card>
    <!-- 现场监控抽屉 -->
    <el-drawer
      title="现场监控"
      :visible.sync="drawer"
      direction="ltr"
      class="drawers"
      size="50%"
    >
      <div class="dra_top">
        <p class="dra_hang">
          <span class="dra_tit"
            >办宴时间：{{ camera.dinnertime.substring(0, 10) }}</span
          ><span>办宴类型：{{ stat(camera.dinnertype) }}</span
          ><span class="dra_tit">参宴人数：{{ camera.dinnerDiners }}人</span>
        </p>
        <p class="dra_hang">
          <span
            >办宴地址：{{ camera.city }},{{ camera.district }},{{
              camera.town
            }},{{ camera.village }},{{ camera.address }}</span
          >
        </p>
        <p class="dra_hang"><span class="dra_tit">办宴点选择：</span></p>
        <p class="dra_hang" style="flex-wrap: wrap; justify-content: normal">
          <span
            class="dra_vid"
            v-for="(item, index) in camera.cameraData"
            :key="index"
            ><i
              :class="placeStat == index ? 'place_dra' : ''"
              class="iconfont icon-shexiangtou"
              @click="look(item, index)"
              ><a>{{ item.banquetPointName }}</a></i
            ></span
          >
        </p>
      </div>

      <div style="width: 90%; margin: 2% auto 4%; height: 560px">
        <p id="playercontainer"></p>
      </div>
      <div class="cameraimg">
        <div
          v-for="(x, j) in videoData.reportCameraInfoList"
          :key="j"
          @click="selectVideo(j, videoData)"
          :class="statVid == j ? 'default_vid' : 'ceshi'"
        >
          <img :src="x.coverUrl" alt="" />
          <p>{{ statVid == j ? "正在播放：" : "" }}{{ x.position }}</p>
        </div>
      </div>
      <div class="dra_btn">
        <p class="dra_hang">
          <span><a>28</a>湿度（RH）</span><span><a>44</a>一氧化碳（ppm）</span
          ><span><a>241</a>烟雾传感（ppm）</span><span><a>7.13</a>酸碱度</span>
        </p>
        <p class="dra_hang">
          <span><a>230</a>甲烷（ppm）</span><span><a>134</a>水质（ppm）</span
          ><span><a>227</a>液化气（ppm）</span
          ><span><a>14.95</a>温度（℃）</span>
        </p>
      </div>
      <!-- <el-drawer :title="`${videoData.banquetPointName}现场视频监控`" :append-to-body="true" direction="ltr" :visible.sync="innerDrawer" size="40%">

      </el-drawer> -->
    </el-drawer>
    <div class="homepage_foot">
      <el-dialog title="溯源信息" width="60%" :visible.sync="dialogVisible">
        <el-table :data="foot.tableData" border stripe style="width: 100%">
          <el-table-column prop="id" label="序号" width="80"></el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="num"
            label="数量"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="place"
            label="产地"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="supplierName"
            label="供应商"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="manufacturer"
            label="生产厂家"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="productionTime"
            label="生产日期"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="days"
            label="保质期（天）"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="buyerName"
            label="采购员"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="warehouseTime"
            label="入库时间"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="addTime"
            label="添加时间"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            width="160"
          ></el-table-column>
          <el-table-column label="是否上架" sortable width="160">
            <template slot-scope="scope">
              <p
                class="boldfont"
                v-if="scope.row.isOnSale == 1"
                style="color: #67c23a"
              >
                是
              </p>
              <p class="boldfont" v-else style="color: #f56c6c">否</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <span
            >共<i class="pagingNum">{{ foot.total }}</i> 条</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="foot.pageNum"
            :page-sizes="[10, 30, 50, 100, 200]"
            :page-size="foot.pageSize"
            layout="sizes, prev, pager, next"
            :total="foot.total"
          ></el-pagination>
        </div>
      </el-dialog>
    </div>
    <div class="homepage_transport">
      <el-dialog title="运输信息" width="60%" :visible.sync="dialogVisible1">
        <baidu-map
          class="map"
          :center="markerPoint"
          :zoom="zoom"
          :scroll-wheel-zoom="true"
          @zoomend="syncCenterAndZoom"
        >
          <!-- 自定义出发点 -->
          <bm-marker
            :position="transportData.initial"
            :icon="{ url: imgentrepot, size: { width: 24, height: 18 } }"
          >
          </bm-marker>
          <!-- 跑过的路线链接 -->
          <bm-polyline
            :path="polylinePath"
            stroke-color="red"
            :stroke-opacity="0.5"
            :stroke-weight="8"
            @lineupdate="updatePolylinePath"
          ></bm-polyline>
          <!-- 目前车辆所在位置 -->
          <bm-marker
            :position="markerPoint"
            :icon="{ url: imgcar, size: { width: 24, height: 18 } }"
            @click="infoWindowOpen"
          >
            <bm-info-window
              :show="show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
            >
              <p>车&nbsp;&nbsp;&nbsp;次：{{ transportData.sn }}</p>
              <p>车牌号：{{ transportData.truckNumber }}</p>
              <p>时&nbsp;&nbsp;&nbsp;速：{{ transportData.speed }} km/h</p>
              <p>司&nbsp;&nbsp;&nbsp;机：{{ transportData.licenseName }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import Paging from "@/components/Paging";
export default {
  name: "homepage",
  components: {
    Paging,
  },
  data() {
    return {
      logininfo: {
        userName: "admin",
      },
      tableData: [],
      tableData1: [],
      userdata: {},
      total: {
        reportNums: 0,
        addReportNums: 0,
        sabNums: 0,
        addSabNums: 0,
        xgNums: 0,
        addXgNums: 0,
        xcNums: 0,
        addXcNums: 0,
      },
      pageNum: 1,
      pageSize: 10,
      // 今日办宴分页
      pageNumTodayDinner: 1,
      pageSizeTodayDinner: 10,
      totalTodayDinner: 0,
      // 今日报备分页
      pageNumTodayReport: 1,
      pageSizeTodayReport: 10,
      totalTodayReport: 0,
      chart: [],
      map: [],
      mapcent: { lng: 105.595974, lat: 30.536857 },
      newcont: "",
      mapstat: "",
      imgred: require("../assets/img/hong.png"),
      imgbule: require("../assets/img/lan.png"),
      imgyellow: require("../assets/img/huang.png"),
      imgcar: require("../assets/img/car.png"),
      imgentrepot: require("../assets/img/entrepot.png"),
      fullscreenLoading: true,
      drawer: false,
      innerDrawer: false,
      camera: { dinnertime: "" },
      videoData: {},
      statVid: "",
      vidStat: 0,
      placeStat: 0,
      dialogVisible: false,
      foot: {
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      dialogVisible1: false,
      polylinePath: [],
      markerPoint: { lng: 116.401856, lat: 39.913927 },
      show: true,
      zoom: 12.8,
      transportData: {},
    };
  },
  created() {
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);
  },
  mounted() {
    // document.title = `${userdata.areasName}乡村群宴智慧管理平台`;
    if (this.userdata.id == 1) {
      document.title = `乡村群宴智慧管理平台`;
    } else if (this.userdata.level == 0) {
      // this.$set(this,'newtit',userdata.areasName)
      document.title = `${this.userdata.areasName}乡村群宴智慧管理平台`;
      // document.title = `智慧群宴管理平台`;
    } else {
      let cityarr = this.userdata.areasName.split(",");
      // this.$set(this,'newtit',cityarr[1])
      document.title = `${cityarr[1]}乡村群宴智慧管理平台`;
      // document.title = `智慧群宴管理平台`;
    }
    //获取首页报备统计数据，并滚动显示
    this.$axios
      .post(
        `/api-r/data/getPlatformInfo/${this.userdata.areasId}`,
        {},
        { headers: { accessToken: this.userdata.token } }
      )
      .then((res) => {
        // console.log(res,'首页数据')
        if (res.data.success) {
          // this.$set(this, "total", res.data);
          _this.$Public.NumAutoPlusAnimation("time1", {
            time: 1000, //总时间
            num: res.data.reportNums , //结束数
            regulator: 8, //调速器
            count: 0,
          });
          _this.$Public.NumAutoPlusAnimation("time1_add", {
            time: 500, //总时间
            num: res.data.addReportNums , //结束数
            regulator: 8, //调速器
            count: 0,
          });
          _this.$Public.NumAutoPlusAnimation("time2", {
            time: 1000, //总时间
            num: res.data.sabNums, //结束数
            regulator: 8, //调速器
            count: 0,
          });
          _this.$Public.NumAutoPlusAnimation("time2_add", {
            time: 500, //总时间
            num: res.data.addSabNums, //结束数
            regulator: 8, //调速器
            count: 0,
          });
          _this.$Public.NumAutoPlusAnimation("time3", {
            time: 1000, //总时间
            num: res.data.xgNums, //结束数
            regulator: 8, //调速器
            count: 0,
          });
          _this.$Public.NumAutoPlusAnimation("time3_add", {
            time: 500, //总时间
            num: res.data.addXgNums, //结束数
            regulator: 8, //调速器
            count: 0,
          });
          _this.$Public.NumAutoPlusAnimation("time4", {
            time: 1000, //总时间
            num: res.data.xcNums , //结束数
            regulator: 8, //调速器
            count: 0,
          });
          _this.$Public.NumAutoPlusAnimation("time4_add", {
            time: 500, //总时间
            num: res.data.addXcNums , //结束数
            regulator: 8, //调速器
            count: 0,
          });
          // this.$set(this, "total", res.data);
          //确保数据和上次有增加，才会滚动增加
          setTimeout(() => {
            this.$set(this, "total", res.data);
          }, 4500);
        } else {
          alert(res.data.msg);
        }
      });
    //定时刷新数据（当前为30秒）
    this.begin();
    const _this = this;
    _this.timer = setTimeout(function () {
    // _this.timer = setInterval(function () {
      _this.$axios
        .post(
          `/api-r/data/getPlatformInfo/${_this.userdata.areasId}`,
          {},
          { headers: { accessToken: _this.userdata.token } }
        )
        .then((res) => {
          _this.$Public.NumAutoPlusAnimation("time1", {
            time: 1000, //总时间
            num: res.data.reportNums , //结束数
            regulator: 8, //调速器
            count: _this.total.reportNums ,
          });
          _this.$Public.NumAutoPlusAnimation("time1_add", {
            time: 500, //总时间
            num: res.data.addReportNums , //结束数
            regulator: 8, //调速器
            count: _this.total.addReportNums ,
          });
          _this.$Public.NumAutoPlusAnimation("time2", {
            time: 1000, //总时间
            num: res.data.sabNums, //结束数
            regulator: 8, //调速器
            count: _this.total.sabNums,
          });
          _this.$Public.NumAutoPlusAnimation("time2_add", {
            time: 500, //总时间
            num: res.data.addSabNums, //结束数
            regulator: 8, //调速器
            count: _this.total.addSabNums,
          });
          _this.$Public.NumAutoPlusAnimation("time3", {
            time: 1000, //总时间
            num: res.data.xgNums, //结束数
            regulator: 8, //调速器
            count: _this.total.xgNums,
          });
          _this.$Public.NumAutoPlusAnimation("time3_add", {
            time: 500, //总时间
            num: res.data.addXgNums, //结束数
            regulator: 8, //调速器
            count: _this.total.addXgNums,
          });
          _this.$Public.NumAutoPlusAnimation("time4", {
            time: 1000, //总时间
            num: res.data.xcNums , //结束数
            regulator: 8, //调速器
            count: _this.total.xcNums ,
          });
          _this.$Public.NumAutoPlusAnimation("time4_add", {
            time: 500, //总时间
            num: res.data.addXcNums , //结束数
            regulator: 8, //调速器
            count: _this.total.addXcNums ,
          });
          _this.$set(this, "total", res.data);
        });
      _this.begin();
    // }, 30000);
    }, 10);
    // this.videoURL = "http://vd2.bdstatic.com/mda-jjku99u1hi9ex1ux/sc/mda-jjku99u1hi9ex1ux.mp4"
  },
  beforeDestroy() {
    clearInterval(this.timer);
    if (this.player != undefined) {
      this.player.remove();
    }
  },
  methods: {
    // 今日办宴分页数据加载
    pageTodayDinner(val) {
      this.pageNumTodayDinner = val.pageNum;
      this.pageSizeTodayDinner = val.pageSize;
      this.getTodayDinnerList();
    },
    // 今日报备分页数据加载
    pageTodayReport(val) {
      this.pageNumTodayReport = val.pageNum;
      this.pageSizeTodayReport = val.pageSize;
      this.getTodayReportList();
    },
    // 获取运输信息
    transport(row) {
      if (!row.orderSn) {
        this.$message("暂无运输信息");
        return;
      }
      this.fullscreenLoading = true;
      this.$axios
        .post(
          `/api-s/getGpsInfoByOrderIdList/${row.orderSn}`,
          {},
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            if (res.data.gpsInfoList.length == 0) {
              this.$message("暂无车辆轨迹信息");
              return;
            }
            let log = [];
            let dataArr = res.data.gpsInfoList;
            dataArr.forEach((x) => {
              log.push({ lng: x.lon, lat: x.lat });
            });
            this.polylinePath = log;
            this.markerPoint = {
              lng: log[log.length - 1].lng,
              lat: log[log.length - 1].lat,
            };
            this.dialogVisible1 = true;
            res.data.transportRecordInfo.initial = {
              lng: log[0].lng,
              lat: log[0].lat,
            };
            res.data.transportRecordInfo.speed =
              dataArr[dataArr.length - 1].spe;
            // 信息处理
            this.transportData = res.data.transportRecordInfo;
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
    updatePolylinePath(e) {
      this.polylinePath = e.target.getPath();
    },
    syncCenterAndZoom(e) {
      this.zoom = e.target.getZoom();
    },
    // 获取溯源信息
    gofoot(row) {
      if (!row.orderSn) {
        this.$message("暂无溯源信息");
        return;
      }
      this.dialogVisible = true;
      this.fullscreenLoading = true;
      let data = this.$qs.stringify({
        pageNum: this.foot.pageNum,
        pageSize: this.foot.pageSize,
        orderSn: row.orderSn,
      });
      this.$axios
        .post(`/api-s/getIngredientListsByOrderSn`, data, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            console.log(res);
            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              this.foot.tableData = res.data.pageInfo.list;
            });
            this.foot.total = res.data.pageInfo.total;
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fullscreenLoading = true;
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.fullscreenLoading = true;
    },
    // 重新选择视频观看
    selectVideo(num, row) {
      this.statVid = num;
      this.playback(num, row);
    },
    playback(num, row) {
      const _this = this;
      _this.videoData = row;
      _this.statVid = num;
      _this.player = cyberplayer("playercontainer").setup({
        width: "100%", // 宽度，也可以支持百分比（不过父元素宽度要有）
        height: "100%", // 高度，也可以支持百分比
        title: row.reportCameraInfoList[num].position, // 标题
        isLive: true, // 必须设置，表明是直播视频
        file: row.reportCameraInfoList[num].liveUrl, // //您的视频源的地址（目前是乐橙示例播放地址）
        image: row.reportCameraInfoList[num].coverUrl, // 预览图
        autostart: false, // 是否自动播放
        stretching: "uniform", // 拉伸设置
        repeat: false, // 是否重复播放
        volume: 0, // 音量，注：仅当用户同意、网站由用户激活或媒体无声时允许自动播放
        controls: true, // 是否显示控制栏
        hls: {
          reconnecttime: 5, // hls直播重连间隔秒数
        },
        ak: "39f82ac87fc3462ea4dcc78734450f57", // 百度智能云平台注册（https://cloud.baidu.com）即可获得accessKey
      });
      _this.fullscreenLoading = false;
    },
    // 观看视频
    look(row, index) {
      const _this = this;
      _this.vidStat = 1;
      _this.placeStat = index;
      this.$nextTick(() => {
        _this.fullscreenLoading = true;
        _this.playback(0, row);
      });
    },
    // 状态处理
    stat(i) {
      if (i == 1) {
        return "红事";
      } else if (i == 2) {
        return "白事";
      } else if (i == 3) {
        return "生日";
      } else if (i == 4) {
        return "状元";
      } else if (i == 5) {
        return "乔迁";
      } else if (i == 6) {
        return "其他";
      }
    },
    // 观看视频
    govideo(row) {
      // 获取摄像头列表和数据
      this.fullscreenLoading = true;
      this.$axios
        .post(
          `/api-r/banquetPoint/getCameraByReportIdList/${row.rid}`,
          {},
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          if (res.data.success) {
            this.fullscreenLoading = false;
            if (res.data.reportBanquetPointInfoList.length > 0) {
              row.cameraData = res.data.reportBanquetPointInfoList;
              this.drawer = true;
              const _this = this;
              _this.camera = row;
              _this.$nextTick(() => {
                _this.playback(0, row.cameraData[0]);
              });
            } else {
              this.$message("该办宴点暂无现场监控");
            }
          }
        });
      this.vidStat = 0;
      this.placeStat = 0;
    },
    off() {
      this.mapstat = 888888;
    },
    imgUrl(item) {
      if (item.dayType == 1) {
        return this.imgred;
      } else if (item.dayType == 2) {
        return this.imgyellow;
      } else if (item.dayType == 3) {
        return this.imgbule;
      }
    },
    ceshi(i, index) {
      this.mapstat = index;
      this.newcont = `<div class="mapcont"><i class="el-icon-close close"></i><p>举办者：<span style="font-weight:600">${
        i.organizer
      }</span></p><p>联系电话：${i.telphone}</p><p>办宴天数：${
        i.dinnerdays
      }</p><p>办宴日期：${i.dinnertime.substring(0, 10)}</p><p>乡厨姓名：${
        i.cookName
      }</p><p>乡厨电话：${i.cookTelphone}</p>
            <p>办宴地址：${i.province}${i.city}${i.district}${
        i.town
      }</p><p>办宴地点：${i.village}</p></div>
            `;
    },
    // 获取报备统计数据
    getHomeReportStaticsInitData() {
        let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        area: this.userdata.areasId,
        level: this.userdata.level,
      });
      this.$axios
        .post(`/api-r/statistics/getHomeReportStaticsInitData`, data, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          // console.log(res, "首页审核");
          this.$set(this, "chart", res.data.reportTotalInfos);
          let myChart = echarts.init(document.getElementById("main"), "light");
          let option = {
            title: {
              text: "今日办宴统计",
              subtext: "",
              x: "center",
              // top:'10px',
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            legend: {
              data: [
                "待审核",
                "已过期",
                "被驳回",
                "待检查",
                "检查合格",
                "检查不合格",
              ],
              orient: "horizontal", // 'vertical'
              x: "center", // 'center' | 'left' | {number},
              y: "45", // 'center' | 'bottom' | {number}
            },
            dataZoom: [
              {
                type: "slider", //数据滑块
                start: 0,
                end: 40,
                height: "10px",
                minSpan: 8,
                dataBackground: {
                  lineStyle: {
                    color: "#fff",
                  },
                  areaStyle: {
                    color: "#fff",
                    opacity: 1,
                  },
                },
              },
              {
                type: "inside", //使鼠标在图表中时滚轮可用
              },
            ],
            grid: {
              bottom: "75px",
              top: "96px",
            },
            xAxis: [
              {
                type: "category",
                data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
              },
            ],
            yAxis: [
              {
                type: "value",
              },
            ],
            series: [
              {
                name: "待审核",
                type: "bar",
                data: [320, 332, 301, 334, 390, 330, 320],
              },
              {
                name: "已过期",
                type: "bar",
                stack: "广告",
                data: [120, 132, 101, 134, 90, 230, 210],
              },
              {
                name: "被驳回",
                type: "bar",
                stack: "广告",
                data: [220, 182, 191, 234, 290, 330, 310],
              },
              {
                name: "待检查",
                type: "bar",
                stack: "广告",
                data: [150, 232, 201, 154, 190, 330, 410],
              },
              {
                name: "检查合格",
                type: "bar",
                stack: "查询引擎",
                data: [620, 732, 701, 734, 1090, 1130, 1120],
              },
              {
                name: "检查不合格",
                type: "bar",
                stack: "查询引擎",
                data: [120, 132, 101, 134, 290, 230, 220],
              },
            ],
          };
          let arr1 = [];
          let arr2 = [];
          let arr3 = [];
          let arr4 = [];
          let arr5 = [];
          let arr6 = [];
          let arr7 = [];
          this.chart.forEach((x) => {
            arr1.push(x.areaName);
            arr2.push(x.total1);
            arr3.push(x.total2);
            arr4.push(x.total3);
            arr5.push(x.total4);
            arr6.push(x.total5);
            arr7.push(x.total6);
          });
          option.xAxis[0].data = arr1;
          option.series[0].data = arr2;
          option.series[1].data = arr3;
          option.series[2].data = arr4;
          option.series[3].data = arr5;
          option.series[4].data = arr6;
          option.series[5].data = arr7;
          myChart.setOption(option);
        });
    },
    // 获取今日报备列表
    getTodayReportList() {
      let data1 = this.$qs.stringify({
        adminAreasId: this.userdata.areasId,
        pageNum: this.pageNumTodayReport,
        pageSize: this.pageSizeTodayReport,
      });
      this.$axios
        .post(`/api-r/report/getTodayReportList`, data1, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          // console.log(res,'首页报备')
          this.$set(this, "tableData", res.data.pageInfo.list);
          this.$set(this, "totalTodayReport", res.data.pageInfo.total);
          // 图表
          let myChart1 = echarts.init(
            document.getElementById("main1"),
            "light"
          );
          let option1 = {
            title: {
              text: "今日报备统计",
              subtext: "",
              x: "center",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              orient: "vertical",
              left: "left",
              data: ["红事", "白事", "生日", "状元", "乔迁", "其他"],
            },
            series: [
              {
                name: "访问来源",
                type: "pie",
                radius: "55%",
                center: ["50%", "60%"],
                data: [
                  { value: 335, name: "红事" },
                  { value: 310, name: "白事" },
                  { value: 234, name: "生日" },
                  { value: 135, name: "状元" },
                  { value: 1548, name: "乔迁" },
                  { value: 165, name: "其他" },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          let num1 = 0,
            num2 = 0,
            num3 = 0,
            num4 = 0,
            num5 = 0,
            num6 = 0;
          res.data.pageInfo.list.forEach((x) => {
            if (x.dinnertype == 1) {
              num1 += 1;
            } else if (x.dinnertype == 2) {
              num2 += 1;
            } else if (x.dinnertype == 3) {
              num3 += 1;
            } else if (x.dinnertype == 4) {
              num4 += 1;
            } else if (x.dinnertype == 5) {
              num5 += 1;
            } else if (x.dinnertype == 6) {
              num6 += 1;
            }
          });
          option1.series[0].data[0].value = num1;
          option1.series[0].data[1].value = num2;
          option1.series[0].data[2].value = num3;
          option1.series[0].data[3].value = num4;
          option1.series[0].data[4].value = num5;
          option1.series[0].data[5].value = num6;
          myChart1.setOption(option1);
        });
    },
    // 获取报备地图数据
    getReportMap() {
      const arr = this.userdata.areasId.split(',')
      const lastAreaId = arr[arr.length - 1]
      this.$axios
        .post(`/api-r/area/${lastAreaId}`, {}, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if(res && res.data && res.data.data) {
            this.mapcent.lng = res.data.data.lng;
            this.mapcent.lat = res.data.data.lat;
          }
          // let lnglat = JSON.parse(sessionStorage.getItem("citylat"));
          // console.log('map', lnglat)
          // if (res.data.mapInfos.length != 0) {
          //   this.$set(this, "map", res.data.mapInfos);
          //   this.mapcent.lng = lnglat.lng;
          //   this.mapcent.lat = lnglat.lat;
          //   res.data.mapInfos.forEach((x) => {
          //     // 今日有办宴重新定位到今日，只限于今日
          //     if (x.dayType == 1) {
          //       this.mapcent.lng = x.lng;
          //       this.mapcent.lat = x.lat;
          //     }
          //   });
          // } else {
          //   this.mapcent.lng = lnglat.lng;
          //   this.mapcent.lat = lnglat.lat;
          // }
        });
    },
    // 获取今日办宴列表
    getTodayDinnerList() {
      // 获取今日办宴
      let dataTodayDinner = this.$qs.stringify({
        adminAreasId: this.userdata.areasId,
        pageNum: this.pageNumTodayDinner,
        pageSize: this.pageSizeTodayDinner,
      });
      this.$axios
        .post(`/api-r/report/getTodayDinnerList`, dataTodayDinner, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$set(this, "tableData1", res.data.pageInfo.list);
            this.$set(this, "totalTodayDinner", res.data.pageInfo.total);
          }
        });
    },
    // 加载数据
    begin() {
      this.getHomeReportStaticsInitData();
      this.getTodayReportList();
      this.getReportMap();
      this.getTodayDinnerList();
    },
  },
};
</script>
<style lang="scss">
.el-drawer__body {
  overflow-y: auto;
}
.cameraimg {
  width: 90%;
  overflow-x: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  // display: flex;
  padding: 0 2%;
  margin: 0 auto 4%;
}
.ceshi {
  width: 22%;
  padding: 1%;
  border: 2px solid #fff;
  text-align: center;
}
.default_vid {
  width: 22%;
  padding: 1%;
  border: 2px solid #11A983;
  text-align: center;
}
.cameraimg > div:hover {
  // width: 22.2%;
  cursor: pointer;
  // border:2px solid #11A983
}
.cameraimg img {
  width: 100%;
}
.cameraimg p {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
.drawers i {
  font-size: 24px;
  cursor: pointer;
  margin-left: 24px;
}
.drawers i a {
  font-size: 18px;
  margin-left: 8px;
}
.place_dra {
  color: #11A983;
}
.drawers .dra_hang {
  display: flex;
  padding: 0 6%;
  align-items: center;
  justify-content: space-between;
  line-height: 38px;
}
.drawers .dra_hang .dra_vid {
  width: 33% !important;
  line-height: 50px;
}
.drawers .dra_tit {
  display: inline-block;
  // width: 50%;
}
.dra_btn {
  margin-bottom: 14%;
}
.dra_btn a {
  display: block;
  color: #11A983;
  font-weight: 600;
}
p {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
$bba: #11A983;
.maps {
  display: flex;
}
.maps .map {
  height: 100%;
}
.map {
  width: 100%;
}
.BMap_Marker img {
  width: 100%;
}
.common {
  margin-bottom: 24px;
}
.common > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  & > div:nth-of-type(1) {
    text-align: left;
    border-left: 5px solid $bba;
    padding-left: 18px;
    width: 94px;
  }
}
.bb {
  font-size: 20px;
  & > i {
    font-style: normal;
    font-size: 14px;
  }
}
.all {
  & > p:nth-of-type(1) {
    font-size: 30px;
    font-weight: 600;
  }
}
.add {
  & span {
    display: inline-block;
    width: 50px;
    margin-left: 3px;
    margin-right: 3px;
    background-color: #11A983;
    line-height: 40px;
    border-radius: 5px;
    font-size: 18px;
    color: rgb(255, 255, 255);
  }
}
// .el-card__header{
//     border: none
// }
.clearfix {
  & > span {
    //font-size: 20px;
    border-left: 5px solid $bba;
    padding-left: 18px;
  }
}
.el-table td,
.el-table th.is-leaf {
  text-align: center;
}
.el-table th > .cell {
  font-size: 18px;
  color: #000;
}
.el-table__empty-text {
  display: block;
  width: 500px;
  height: 190px;
  padding-top: 100px;
  background: url(../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
.bdechart {
  width: 49%;
  float: left;
  margin-top: 24px;
}
.onecha {
  margin-right: 1.6%;
}
.mapcont {
  background: #fff;
  color: #000;
  position: absolute;
  left: -50px;
  padding: 10px;
  font-size: 12px;
  z-index: 9999;
}
.mapcont > p {
  line-height: 20px;
}
.maptit {
  position: absolute;
  top: 0;
  z-index: 99;
  background: rgba(255, 255, 255, 0.8);
  width: 94%;
  line-height: 26px;
  display: flex;
  justify-content: space-between;
  padding: 12px 3%;
}
.maptit img {
  width: 18px;
  margin: -2px 4px;
}
.close {
  float: right;
  font-size: 16px;
  cursor: pointer;
}
.f18 {
  color: #11A983;
  cursor: pointer;
}
.f19 {
  color: #67c23a;
  cursor: pointer;
}
.f20 {
  color: #409eff;
  cursor: pointer;
}
.c99 {
  color: #999;
}
.drawers .dra_top .dra_hang > span:last-child {
  // width: 40%
}
.drawers .dra_btn .dra_hang {
  justify-content: space-around;
  text-align: center;
  margin-bottom: 4%;
}
.drawers .dra_btn .dra_hang span {
  width: 25%;
}
// 溯源
.homepage_foot .el-dialog__body {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
// 运输
.homepage_transport .map {
  height: 100%;
}
</style>
